import { FadeUp, MaskedLine, Stagger, StaggerItem } from "../components/Reveal";
import { aboutBio, disciplines, site } from "../data/content";

export default function About() {
  return (
    <div className="pt-32 md:pt-44">
      <header className="mx-auto max-w-7xl px-6">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-blue">
          About
        </p>
        <h1 className="mt-6 font-display font-extrabold leading-[0.95] tracking-[-0.03em] text-[clamp(3rem,9vw,8rem)]">
          <MaskedLine delay={0.15}>BETWEEN THE BRIEF</MaskedLine>
          <MaskedLine delay={0.28}>
            <span className="text-blue">AND THE BEHAVIOUR.</span>
          </MaskedLine>
        </h1>
      </header>

      <section className="mx-auto grid max-w-7xl gap-14 px-6 py-20 md:grid-cols-12 md:py-28">
        <div className="md:col-span-5">
          <FadeUp>
            <div className="relative aspect-[3/4] overflow-hidden border border-line bg-fog">
              <img
                src="/images/arush-portrait.webp"
                alt="Arush Tandon — portrait"
                className="h-full w-full object-cover"
                data-testid="about-portrait"
              />
            </div>
            <div className="mt-6 border-t border-ink pt-4">
              <p className="font-display text-lg font-bold tracking-tight">{site.name}</p>
              <p className="mt-1 text-sm text-smoke">{site.role}</p>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke">
                {site.company}
              </p>
            </div>
          </FadeUp>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          {aboutBio.map((p, i) => (
            <FadeUp key={i} delay={0.08 * i}>
              <p
                className={`mb-6 leading-relaxed ${
                  i === 0
                    ? "font-display text-xl font-semibold tracking-tight text-ink md:text-2xl"
                    : "text-base text-smoke"
                }`}
              >
                {p}
              </p>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="border-y border-line bg-fog/60">
        <div className="mx-auto max-w-7xl px-6 py-20 md:py-28">
          <FadeUp>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-blue">
              Fields of play
            </p>
            <h2 className="mt-4 font-display font-bold tracking-tight text-[clamp(1.8rem,4vw,3.5rem)]">
              ELEVEN DISCIPLINES, ONE JOB: BEHAVIOUR.
            </h2>
          </FadeUp>
          <Stagger className="mt-14 grid border-l border-t border-line sm:grid-cols-2 lg:grid-cols-3">
            {disciplines.map((d, i) => (
              <StaggerItem
                key={d}
                className="group flex items-baseline gap-4 border-b border-r border-line p-6 transition-colors duration-300 hover:bg-paper md:p-8"
              >
                <span className="font-mono text-[10px] tracking-[0.2em] text-blue">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display text-lg font-semibold tracking-tight transition-colors duration-300 group-hover:text-blue md:text-xl">
                  {d}
                </span>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-20 md:py-28">
        <FadeUp>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">
            Currently
          </p>
          <div className="mt-6 flex flex-wrap items-baseline justify-between gap-4 border-t border-ink pt-6">
            <p className="font-display text-2xl font-bold tracking-tight md:text-4xl">
              Associate Manager — Strategy &amp; Planning
            </p>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-smoke">
              Impact Communications · India
            </p>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
